import type { LegacyRef } from 'react';

interface ActionListProps<T> {
  actions: ActionType<T>[];
}

type ActionType<T> = {
  name: Actions;
  disabled?: boolean;
  onclick: (value?: T) => T | void;
};

type Actions = 'addResource' | 'addData' | 'delete' | 'update' | 'detail';

const actionIcons: Record<Actions, string> = {
  addResource: 'plus',
  addData: 'plus',
  delete: 'trash',
  update: 'pencil',
  detail: 'info',
};

const actionPrettyNames: Record<Actions, string> = {
  addResource: 'Ajouter une ressource',
  addData: 'Ajouter une donnée',
  delete: 'Supprimer',
  update: 'Modifier',
  detail: 'Détails',
};

function ActionList<T>(
  { actions }: ActionListProps<T>,
  _ref: LegacyRef<HTMLDivElement>
) {
  return (
    <div className="uk-inline">
      <button className="" type="button" uk-icon="more"></button>
      <div uk-dropdown="mode: click">
        <ul className="uk-nav uk-dropdown-nav action-list">
          {actions.map((action) => (
            <li
              key={action.name}
              className={`uk-active action ${
                action.disabled ? 'disabled' : ''
              }`}
              style={{ cursor: 'pointer' }}
              onClick={
                !action.disabled
                  ? () => {
                      action.onclick();
                    }
                  : () => {}
              }
            >
              {actionPrettyNames[action.name]}
              <span uk-icon={`${actionIcons[action.name]}`}></span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ActionList;
